import { Bot, User, Info } from 'lucide-react';
import type { ChatMessage } from '../../hooks/useAgentSession';

interface AgentMessageProps {
  message: ChatMessage;
  isStreaming?: boolean;
}

export default function AgentMessage({ message, isStreaming }: AgentMessageProps) {
  if (message.role === 'system') {
    return (
      <div className="flex items-start gap-2 px-4 py-2 animate-fadeIn">
        <Info className="w-4 h-4 text-blue-500 mt-0.5 shrink-0" />
        <p className="text-sm text-blue-700 italic">{message.content}</p>
      </div>
    );
  }

  const isUser = message.role === 'user';

  return (
    <div className={`flex items-start gap-3 px-4 py-3 animate-fadeIn ${isUser ? 'bg-gray-50' : ''}`}>
      <div
        className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 ${
          isUser ? 'bg-gray-200' : 'bg-blue-100'
        }`}
      >
        {isUser ? (
          <User className="w-4 h-4 text-gray-600" />
        ) : (
          <Bot className="w-4 h-4 text-blue-600" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-medium text-gray-500 mb-1">
          {isUser ? 'You' : 'Resume Coach'}
        </p>
        <div className="text-sm text-gray-800 whitespace-pre-wrap prose prose-sm max-w-none">
          {message.content}
          {isStreaming && (
            <span className="inline-block w-1.5 h-4 bg-blue-500 ml-0.5 animate-pulse" />
          )}
        </div>
      </div>
    </div>
  );
}
